export function addNumbersAndResolvePrecision(n1, n2) {
    var fixedDecimalsResult = (n1 + n2).toFixed(9);
    return Number(fixedDecimalsResult);
}
export function equalsWithTolerance(n1, n2, tolerance) {
    return Math.abs(n1 - n2) <= tolerance;
}

//# sourceMappingURL=number-precision.js.map